// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__swkOr","tabSelect":"style_tabSelect__aVi_G","tab":"style_tab__Q_9el","active":"style_active__EqeQn"};